<template>
  <div class="topic-title clearfix">
    <span class="topic-name">{{topicName}}</span>
    <span class="topic-count">{{recordCount}}</span>
  </div>
</template>

<script>
export default {
  name: "titleBar",
  props:{
    topicName: String,
    topicCount: Number
  },
  computed:{
    recordCount:function (){
      return this.topicCount + '查看';
    }
  }
}
</script>

<style scoped>
.topic-title{
  background: #fff;
  border-bottom: 1px solid #eee;
  height: 50px;
  line-height:50px;
  padding-left:10px;
  padding-right:10px;
}

.topic-name{
  display: block;
  font-size: 20px;
  font-weight: bold;
  float: left;
}

.topic-count{
  display: block;
  float: right;
  font-size: 12px;
  color: #666;
}
</style>
